import { render } from "./InboundEdit.vue?vue&type=template&id=7ebb8c5f&scoped=true"
import script from "./InboundEdit.vue?vue&type=script&lang=js"
export * from "./InboundEdit.vue?vue&type=script&lang=js"

import "./InboundEdit.vue?vue&type=style&index=0&id=7ebb8c5f&lang=scss&scoped=true"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebb8c5f"]])

export default __exports__